import React from 'react';
import {ChangePasswordForm} from './sub-view/change-password-form';
import {UserLayout} from 'components/layouts/user';

class ProfileContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout>
        <h1 className="user-header">Thay đổi mật khẩu</h1>
        <ChangePasswordForm/>
      </UserLayout>
    );
  }
}

export default ProfileContainer;



// WEBPACK FOOTER //
// ./components/users/ChangePasswordContainer.jsx